<div class="content-wrapper">
    <div class="page-header">
        <h3 class="page-title" style="cursor: context-menu;">
            <span class="page-title-icon bg-gradient-success text-white mr-2">
                <i class="mdi mdi-calculator menu-icon"></i>
            </span> การคำนวณดอกเบี้ยเงินกู้แบบละเอียด / ค่าปรับ
        </h3>
        <nav aria-label="breadcrumb">
            <button type="button" class="btn btn-gradient-success" data-toggle="modal" data-target="#mlr"
                style="cursor: pointer;">อัตราดอกเบี้ย MLR</button>
            <div class="modal fade" id="mlr" tabindex="-1" role="dialog" aria-labelledby="อัตราดอกเบี้ย MLR"
                aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content" style="background-color: white;">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel-2">อัตราดอกเบี้ย MLR
                                ตามประกาศธนาคารกรุงไทย
                            </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="table-responsive">
                                <table class="table table-bordered" style="border-top: 1px solid #ebedf2;">
                                    <thead>
                                        <tr style="text-align: center;">
                                            <th style="font-weight: 500;"> อัตราดอกเบี้ย </th>
                                            <th style="font-weight: 500;"> มีผลบังคับใช้ ณ วันที่</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style="text-align: center;" *ngFor="let mlr of mlr| paginate : {
                                                itemsPerPage: tableSize,
                                                currentPage: page,
                                                totalItems: count
                                              };">
                                            <td> {{mlr.interest | number: '1.3-3'}} </td>
                                            <td> {{mlr.use}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div><br>
                            <pagination-controls previousLabel="ก่อนหน้า" nextLabel="ถัดไป" class="my-pagination"
                                (pageChange)="onTableDataChange($event)" style="text-align: center;">
                            </pagination-controls>
                        </div>
                    </div>
                </div>
            </div>
            <button *ngIf="!display_list" title="ย้อนกลับ" (click)="onClickBack()" type="button"
                style="margin-left: 10px;" class="btn btn-gradient-success">ย้อนกลับ</button>
        </nav>
    </div>
    <div class="row">
        <div class="col-12 grid-margin">
            <div class="card" style="border-radius: 15px;">
                <div class="card-body" *ngIf="display_list" id="list">
                    <div class="row"
                        style="width: fit-content; margin-right: 0px; margin-left: auto; margin-top: 10px;">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-gradient-success text-white"> ค้นหา </span>
                            </div>
                            <input type="text" class="form-control" list="id-project" id="search" name="search"
                                [(ngModel)]="search.debt_name" (ngModelChange)="onSearch()" placeholder="ชื่อโครงการ">
                        </div>
                        <datalist id="id-project">
                            <option *ngFor="let debt of debt_all" [value]="debt.project_name">{{debt.project_name}}</option>
                        </datalist>
                    </div><br>
                    <div class="table-responsive">
                        <table class="table table-striped" style="cursor: context-menu;">
                            <thead>
                                <tr class="text-center">
                                    <th class="tab-15"> ลำดับที่ </th>
                                    <th class="tab-30"> ชื่อลูกหนี้ </th>
                                    <th class="tab-45"> ชื่อโครงการ </th>
                                    <th class="tab-15"> </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let data of debt_view">
                                    <td class="tab-10 text-center"> {{data.debt_id}} </td>
                                    <td class="tab-30 text-left"> {{data.debt_name}} </td>
                                    <td class="tab-45 text-left"> {{data.project_name}} </td>
                                    <td class="tab-15 text-center"> <button title="ดูเพิ่มเติม"
                                            (click)="onClickDetail(data)" class="btn btn-light btn-sm"
                                            style="margin-right: 10px;"><i
                                                class="mdi mdi-eye text-success"></i></button> </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="card-body" *ngIf="!display_list" id="table">
                    <div id="table">
                        <img src="https://cdn2.iconfinder.com/data/icons/mixed-vol-7/74/Untitled-1-11-08-07-17-512.png"
                            (click)="maximizeorMinimize('table','btn')" width="15px" height="15px" id="btn"
                            style="float: right; margin-top: 0px; margin-right: 0px; margin-bottom: 10px;"
                            title="Maximize">
                        <div id="print-section">
                            <div class="text-center" style="width: 100%; text-align: center; cursor: context-menu;">
                                <h4>ตารางสรุปการชำระเงินต้นและดอกเบี้ย{{debt_select.type_money}} -
                                    {{debt_select.debt_name}}</h4>
                                <h4>{{debt_select.project_name}}</h4>
                            </div><br>
                            <div class="table-responsive table-h60">
                                <table class="table table-bordered table-hover"
                                    style="border: 1px solid #ebedf2; border-collapse: collapse;width: 100%; cursor: context-menu;">
                                    <thead>
                                        <tr style="text-align: center;">
                                            <th class="sticky-row first-row first-col" rowspan="2"
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 500;">
                                                ปี งปม.
                                            </th>
                                            <th class="sticky-col first-row" rowspan="2"
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 500;">
                                                งวดที่ </th>
                                            <th class="sticky-col first-row" rowspan="2"
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 500;">
                                                วันครบกำหนดคิดดอกเบี้ย </th>
                                            <th class="sticky-col first-row" rowspan="2"
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 500;">
                                                วันครบกำหนดชำระ </th>
                                            <th class="sticky-col first-row" rowspan="2"
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 500; min-width: 100px;">
                                                วันที่ชำระเงิน </th>
                                            <th class="sticky-col first-row" colspan="3"
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 500;">
                                                <ng-container *ngIf="debt_select.duration.year!=0">{{debt_select.duration.year}} ปี </ng-container>
                                                <ng-container *ngIf="debt_select.duration.month!=0">{{debt_select.duration.month}} เดือน </ng-container>
                                                ({{debt_select.date_agree}} งวด )
                                            </th>
                                            <th class="sticky-col first-row" rowspan="2"
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 500;">
                                                การคิดดอกเบี้ย </th>
                                            <th class="sticky-col first-row" rowspan="2"
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 500;">
                                                หมายเหตุ </th>
                                        </tr>
                                        <tr style="text-align: center;">
                                            <th class="sticky-col sec-row"
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 500;">
                                                เงินต้น </th>
                                            <th class="sticky-col sec-row"
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 500;">
                                                ดอกเบี้ย </th>
                                            <th class="sticky-col sec-row"
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 500;">
                                                รวม </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let data of arr_finalDebt ; let i = index">
                                            <td class="sticky-col first-col"
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 400; text-align: center;">
                                                <span *ngIf="data.year_ac>1">{{data.year_ac}}</span>
                                                <span *ngIf="data.year_ac==0">N/A</span>
                                                <span *ngIf="data.year_ac==1"></span>
                                            </td>
                                            <td
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 400; text-align: center;">
                                                {{data.year}}
                                            </td>
                                            <td
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 400; text-align: center;">
                                                {{data.date_debtTH}}
                                            </td>
                                            <td
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 400; text-align: center;">
                                                {{data.date_payTH}}
                                            </td>
                                            <td
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 400; text-align: center;">
                                                {{data.date_actualPayTH}}
                                            </td>
                                            <td
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 400; text-align: right;">
                                                <span *ngIf="data.principle!=0">{{data.principle |
                                                    number:'1.2-2'}}</span>
                                            </td>
                                            <td
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 400; text-align: right;">
                                                <span *ngIf="data.interest!=0 && data.interest">{{data.interest
                                                    | number:'1.2-2'}}</span>
                                            </td>
                                            <td
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 400; text-align: right;">
                                                <span *ngIf="data.sum!=0">{{data.sum |
                                                    number:'1.2-2'}}</span>
                                            </td>
                                            <td
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 400; text-align: center;">
                                                {{data.duration}}
                                            </td>
                                            <td
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 400; text-align: center;">
                                                {{data.remark}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="sticky-col first-col"
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 400; text-align: center;">

                                            </td>
                                            <td colspan="4"
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 500; text-align: center;">
                                                รวม
                                            </td>
                                            <td
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 500; text-align: right;">
                                                <span *ngIf="sum_calData.principle!=0">{{sum_calData.principle
                                                    | number:'1.2-2'}}</span>
                                            </td>
                                            <td
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 500; text-align: right;">
                                                <span *ngIf="sum_calData.interest!=0">{{sum_calData.interest
                                                    | number:'1.2-2'}}</span>
                                            </td>
                                            <td
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 500; text-align: right;">
                                                <span *ngIf="sum_calData.sum!=0">{{sum_calData.sum |
                                                    number:'1.2-2'}}</span>
                                            </td>
                                            <td colspan="2"
                                                style="border: 1px solid #ebedf2; vertical-align: middle; padding: 10px; font-weight: 400; text-align: center;">

                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div><br>
                            <div style="width: 100%;margin-left: auto;margin-right: auto;display: -webkit-box;
                            display: -ms-flexbox;
                            display: flex;
                            -ms-flex-wrap: wrap;
                            flex-wrap: wrap;">
                                <table class="col-6" style="height: fit-content; cursor: context-menu; width: 50%;">
                                    <!-- <tr>
                                        <td style="font-weight: 400; font-size: 11pt; vertical-align: top;">
                                            หมายเหตุ : &nbsp;
                                        </td>
                                        <td style="font-weight: 300; font-size: 11pt; vertical-align: top;">
                                            จ่ายคืนเงินให้กู้ยืมทุกวันที่ {{debt_select.debt_pay_th}}
                                            ของทุกปี</td>
                                    </tr>
                                    <tr>
                                        <td style="font-weight: 300; font-size: 11pt;"> </td>
                                        <td style="font-weight: 300; font-size: 11pt; vertical-align: top;">
                                            ดอกเบี้ยในแต่ละงวด
                                            คิดดอกเบี้ยถึง {{debt_select.notify_amount_th}} ของทุกปี</td>
                                    </tr> -->
                                    <tr>
                                        <td style="font-weight: 400; font-size: 11pt; vertical-align: top;">
                                            หมายเหตุ : &nbsp;
                                        </td>
                                        <td style="font-weight: 300; font-size: 11pt; vertical-align: top;">
                                            ระยะเวลาการปลอดต้น
                                            {{debt_select.gp_principle}} ปี</td>
                                    </tr>
                                    <tr>
                                        <td style="font-weight: 300; font-size: 11pt;"> </td>
                                        <td style="font-weight: 300; font-size: 11pt; vertical-align: top;">
                                            ระยะเวลาการปลอดดอกเบี้ย {{debt_select.gp_interest}} ปี</td>
                                    </tr>
                                </table>
                                <div class="col-6" style="height: fit-content; cursor: context-menu; width: 50%;">
                                    <a class="text2"
                                        style="font-size: 11pt;font-weight: 400;">ดอกเบี้ยค้างรับ</a>
                                    <table style="width: 100%;">
                                        <tbody>
                                            <tr class="text-center" *ngFor="let data of accrued_interest">
                                                <td class="text2"
                                                    style="font-weight: 300; font-size: 11pt;"> ณ วันที่
                                                    {{data.year}} </td>
                                                <td class="text2"
                                                    style="font-weight: 300; font-size: 11pt;"> = </td>
                                                <td class="text2 text-right"
                                                    style="font-weight: 300; font-size: 11pt;">
                                                    {{data.total | number:'1.2-2'}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div><br>
                    </div>
                    <div class="text-center"><br>
                        <button class="btn btn-inverse-info btn-fw" printTitle="ตารางสรุปการชำระเงินต้นและดอกเบี้ย{{debt_select.type_money}} -
                                                {{debt_select.debt_name}}" printSectionId="print-section"
                            ngxPrint>พิมพ์รายงาน</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>